import { Box, Image } from '@chakra-ui/react';
import { TextBold } from 'UiKit/typography';
import getRankBadge from 'Helper/getRankBadge';
import { SIZE_CONFIG } from 'Component/achievement-rank/const';

import styles from './styles.module.css';

const AchievementRank = ({ rankPosition, size = 'sm' }) => {
  const rankBadge = getRankBadge(rankPosition);
  const { badgeSize, fontSize } = SIZE_CONFIG[size];
  const translateX = rankPosition >= 10 ? '-50%' : '-60%';

  return (
    <Box className={styles['achievement-rank__container']} width={badgeSize} height={badgeSize}>
      <Box className={styles['rank-text__container']} transform={`translateX(${translateX})`}>
        <TextBold className={styles['rank__text']} fontSize={fontSize}>
          {rankPosition}
        </TextBold>
      </Box>
      <Image width={badgeSize} src={rankBadge} />
    </Box>
  );
};

export default AchievementRank;
